import PropTypes from 'prop-types';
import CocTestResultIndicator from '../../../CoC/CoCTestResultIndicator/cocTestResultIndicator';

import './cocTestResultCell.scss';

export default function CocTestResultCell({
                                           value = null,
                                         }) {

  return  <CocTestResultIndicator result={value}/>;
}

CocTestResultCell.propTypes = {
  value : PropTypes.string,
};
